import MembershipBanner from "./sections/membership-price-banner/index"
import MembershipAnchor from "./sections/membership-price-anchor/index"
import MembershipRules from "./sections/membership-price-rules/index"
import MembershipBenefits from "./sections/membership-price-benefits/index"

// 无活动
import MembershipNoActivity from "./sections/membership-price-no-activity/index"

document.addEventListener('DOMContentLoaded', () => {
  // 倒计时
  new MembershipBanner()

  // anchor
  let membershipAnchorInstance = null
  setTimeout(() => {
    membershipAnchorInstance = new MembershipAnchor()
  }, 300)
  // 页面卸载时清理
  window.addEventListener('beforeunload', () => {
    if (membershipAnchorInstance) {
      membershipAnchorInstance.destroy()
    }
  })

  // swiper
  let membershipBenefitsInstance = new MembershipBenefits({
    el: '.membership-price-benefits-swiper',
  })
  // 页面卸载时清理
  window.addEventListener('beforeunload', () => {
    if (membershipBenefitsInstance) {
      membershipBenefitsInstance.destroy()
    }
  })
  
  // rules
  new MembershipRules()

  // no-activity
  new MembershipNoActivity()
})
